// src/Dashboard/pages/user/Absences/components/AbsenceSignalForm.jsx

import React from "react";
import {
  FaCalendarCheck,
  FaExclamationTriangle,
  FaHeartbeat,
  FaRegCalendarAlt,
  FaUserInjured,
} from "react-icons/fa";
import { FaArrowRotateRight } from "react-icons/fa6";

import Button from "../../../../components/Button/Button";
import StatusBadge from "./StatusBadge";
import TypeButton from "./TypeButton";

const TYPE_BUTTONS = [
  {
    value: "Absent(e)",
    icon: FaRegCalendarAlt,
  },
  {
    value: "Malade",
    icon: FaHeartbeat,
  },
  {
    value: "Blessé(e)",
    icon: FaUserInjured,
  },
];

export default function AbsenceSignalForm({
  selectedAdherent,
  selectedStatus,
  absenceType,
  setAbsenceType,
  isBlessed,
  setIsBlessed,
  dateReprise,
  setDateReprise,
  motifAbsence,
  setMotifAbsence,
  returnDateWarning,
  saving,
  onSubmit,
  onReset,
}) {
  return (
    <form
      onSubmit={onSubmit}
      className="rounded-[1.5rem] border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-950 sm:p-5"
    >
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <p className="text-sm font-bold text-slate-950 dark:text-white">
            Nouveau signalement
          </p>

          <p className="mt-1 text-xs leading-5 text-slate-500 dark:text-slate-400">
            Indiquez le type d’absence, la date estimée de reprise et un motif
            si nécessaire.
          </p>
        </div>

        {selectedStatus && (
          <div className="shrink-0">
            <StatusBadge adherent={selectedAdherent} />
          </div>
        )}
      </div>

      <div className="mt-5">
        <label className="mb-2 block text-sm font-bold text-slate-800 dark:text-slate-100">
          Type de signalement
        </label>

        <div className="grid grid-cols-1 gap-2 sm:grid-cols-3">
          {TYPE_BUTTONS.map((item) => (
            <TypeButton
              key={item.value}
              value={item.value}
              icon={item.icon}
              active={absenceType === item.value}
              onClick={setAbsenceType}
            />
          ))}
        </div>
      </div>

      <div className="mt-5 rounded-2xl border border-slate-200 bg-slate-50 p-3 dark:border-slate-700 dark:bg-slate-900/70">
        <label className="flex cursor-pointer items-center justify-between gap-4">
          <span>
            <span className="block text-sm font-bold text-slate-900 dark:text-white">
              L’adhérent est actuellement absent
            </span>

            <span className="mt-0.5 block text-xs leading-5 text-slate-500 dark:text-slate-400">
              Activez ce statut pour prévenir le bureau et les enseignants.
            </span>
          </span>

          <input
            type="checkbox"
            checked={isBlessed}
            onChange={(event) => setIsBlessed(event.target.checked)}
            className="h-5 w-5 accent-violet-600"
          />
        </label>
      </div>

      <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div>
          <label className="mb-1.5 block text-sm font-bold text-slate-800 dark:text-slate-100">
            Date de reprise estimée
          </label>

          <input
            type="date"
            className="min-h-12 w-full rounded-2xl border border-slate-300 bg-white px-4 text-sm font-semibold text-slate-900 outline-none transition focus:ring-2 focus:ring-violet-300 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100"
            value={dateReprise}
            onChange={(event) => setDateReprise(event.target.value)}
          />
        </div>

        <div>
          <label className="mb-1.5 block text-sm font-bold text-slate-800 dark:text-slate-100">
            Motif d’absence
          </label>

          <input
            type="text"
            className="min-h-12 w-full rounded-2xl border border-slate-300 bg-white px-4 text-sm font-semibold text-slate-900 outline-none transition focus:ring-2 focus:ring-violet-300 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100"
            placeholder="Grippe, genou, déplacement..."
            value={motifAbsence}
            onChange={(event) => setMotifAbsence(event.target.value)}
          />
        </div>
      </div>

      {returnDateWarning && (
        <div className="mt-4 flex items-start gap-3 rounded-2xl border border-amber-200 bg-amber-50 p-3 text-sm leading-6 text-amber-800 dark:border-amber-500/20 dark:bg-amber-500/10 dark:text-amber-200">
          <FaExclamationTriangle className="mt-1 shrink-0" />
          <p>{returnDateWarning}</p>
        </div>
      )}

      <div className="mt-5 flex flex-col gap-2 sm:flex-row sm:justify-end">
        <button
          type="button"
          onClick={onReset}
          className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 text-sm font-bold text-slate-700 transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800"
        >
          <FaArrowRotateRight />
          Réinitialiser
        </button>

        <Button
          type="submit"
          text={saving ? "Enregistrement…" : "Enregistrer l’absence"}
          icon={FaCalendarCheck}
          className="!min-h-12 !rounded-2xl gap-2"
          disabled={!selectedAdherent || saving}
        />
      </div>
    </form>
  );
}